<template>

    <div class="bg-gray-200 min-h-screen flex items-center justify-center">
        <div
            class="flex w-full max-w-sm mx-auto overflow-hidden bg-gray-300 rounded-lg shadow-lg lg:max-w-4xl px-6 py-16  my-16">
            <div class="auth-bg hidden bg-cover lg:block lg:w-1/2 rounded-md">
            </div>

            <div class="w-full px-6 py-8 md:px-8 lg:w-1/2">
                <div class="flex justify-center mx-auto">
                    <img :class="{
                        'icon-animated-left ': isFocusedLeft,
                        'icon-animated-rigth': isFocusedRigth
                    }" class="w-auto h-7 sm:h-8 icon-picklog" src="/favicon_pick&log.ico" alt="">
                </div>

                <p class="mt-3 text-xl text-center text-gray-600">
                    ¡Bienvenido!
                </p>


                <div class="mt-4">
                    <label class="block mb-2 text-sm font-medium text-gray-600"
                        for="LoggingEmailAddress">Usuario:</label>
                    <input id="LoggingEmailAddress" @focus="setFocusLeft(true)" @blur="setFocusLeft(false)"
                        @keydown.enter="handlerFormSubmit" v-model="loginData.username"
                        placeholder="Ingrese nombre de usuario"
                        class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40  focus:outline-none focus:ring focus:ring-blue-300"
                        type="username" required />
                </div>

                <div class="mt-4">
                    <div class="flex justify-between">
                        <label class="block mb-2 text-sm font-medium text-gray-600"
                            for="loggingPassword">Contraseña:</label>
                    </div>

                    <input id="loggingPassword" @focus="setFocusRigth(true)" @blur="setFocusRigth(false)"
                        @keydown.enter="handlerFormSubmit" v-model="loginData.password"
                        placeholder="Ingrese su contraseña"
                        class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg focus:border-blue-400 focus:ring-opacity-40 focus:outline-none focus:ring focus:ring-blue-300"
                        type="password" required />
                </div>

                <div class="flex items-center justify-center h-[35px]">
                    <p class="text-center text-red-600 font-semibold">{{ statusAuthMessage }}</p>
                </div>

                <div class="mt-3">
                    <button @click="handlerFormSubmit"
                        class="w-full px-6 py-3 text-sm font-medium tracking-wide capitalize transition-colors duration-300 transform rounded-lg custom-button hover:ring-1 hover:ring-orange-400">
                        Iniciar sesion
                    </button>
                </div>

            </div>
        </div>
    </div>

    <!-- Loading session -->
    <ModalLoading v-if="modalState" :open="modalState" />

</template>



<script setup lang="ts">

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

import { fetchLogin } from './composables/LoginAuth';
import { dataUserAuthenticated } from './composables/ExtractDataUser';
import { useUserAuthenticatedStore } from './stores/UserAuthenticated.store';
import ModalLoading from '../OrderShipmentData/ModalLoading/ModalLoading.vue';




const router = useRouter()

// USER STORE/PINIA
const userStore = useUserAuthenticatedStore()



const loginData = ref({
    username: '',
    password: ''
})

const isValidLogin = computed(() => {
    return loginData.value.password && loginData.value.username
})


// Logica: VACIO
const isFocusedLeft = ref(false)
const isFocusedRigth = ref(false)

const statusAuthMessage = ref('')

const modalState = ref(false)

const setFocusLeft = (value: boolean) => {
    isFocusedLeft.value = value
}

const setFocusRigth = (value: boolean) => {
    isFocusedRigth.value = value
}


// Funcion para iniciar sesion
const handlerFormSubmit = async () => {

    if (!isValidLogin.value) {
        statusAuthMessage.value = ''
        statusAuthMessage.value = 'Debe completar los campos'
        return
    }
    try {
        modalState.value = true
        statusAuthMessage.value = ''
        const responseLogin = await fetchLogin(loginData.value.username, loginData.value.password)

        if (!responseLogin?.status) {
            console.error('Error en inicio de sesion')
            modalState.value = false
            statusAuthMessage.value = 'Usuario o contraseña inválido'
            return;
        }


        const userData = await dataUserAuthenticated() // <- Funcion para extraer los datos del usuario autenticado.


        if (!userData) {
            console.error("Error al extraer la cookie o conexion a los datos del usuario ")
            modalState.value = false
            statusAuthMessage.value = 'Error de authenticacion'
            return;
        }


        userStore.updateUserStore(userData)
        modalState.value = false
        statusAuthMessage.value = ''
        router.replace('table-content')

    } catch (error) {
        console.error('Error en la autenticacion: ', error)
        return false
    }

}


</script>




<style scoped>
.auth-bg {
    background-image: url('../../assets/auth_img2.webp');
}

.custom-button {
    background-color: #f1b15a;
    color: white;
}

.custom-button:hover {
    background-color: #f3bc74;
    /* versión más clara para hover */
}

.custom-button:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(241, 177, 90, 0.5);
    /* ring con el mismo color pero con opacidad */
}

.icon-picklog {
    transition: transform 0.3s ease, color 0.3s ease;
}

.icon-animated-left {
    transform: scale(1.2) rotate(20deg);
}

.icon-animated-rigth {
    transform: scale(1.2) rotate(-20deg);
}
</style>